export { CELL_TYPE, NumericCellType } from "./numericType.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/numericType/index.mjs
// module id = 1109
// module chunks = 1